import { render, staticRenderFns } from "./create.vue?vue&type=template&id=d5a830b6&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5a830b6')) {
      api.createRecord('d5a830b6', component.options)
    } else {
      api.reload('d5a830b6', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=d5a830b6&", function () {
      api.rerender('d5a830b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/beneficiary/create.vue"
export default component.exports